<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <rect class="cls-1" x="0" y="0" width="90.07" height="90.07"/>
  <path class="cls-3" d="M5.64,18.67l15.64,4.56c.99,.29,1.76,1.07,2.04,2.06l9.66,34.27c.36,1.29,1.54,2.18,2.87,2.18h29.13c1.24,0,2.35-.77,2.79-1.93l9.8-25.85c.74-1.95-.7-4.05-2.79-4.05H30.63"/>
  <circle class="cls-2" cx="39.18" cy="70.65" r="4.37"/>
  <circle class="cls-2" cx="62.04" cy="70.65" r="4.37"/>
  <path class="cls-4" d="M52.61,35.01l-.02,2.53c1,.1,1.93,.3,2.81,.59,.88,.3,1.63,.67,2.26,1.12l-1.2,3.28c-.67-.48-1.47-.86-2.38-1.14-.92-.28-1.85-.43-2.8-.44-.95,0-1.62,.12-2,.38-.39,.26-.58,.58-.58,.96,0,.32,.13,.6,.39,.82,.26,.22,.73,.42,1.42,.57l2.6,.57c2.82,.65,4.22,2.18,4.2,4.61,0,1.29-.45,2.38-1.32,3.27-.87,.89-2.04,1.47-3.5,1.74l-.02,2.65-3.2-.02,.02-2.58c-.8-.1-1.56-.3-2.29-.59-.73-.3-1.32-.66-1.8-1.09l1.15-3.07c.55,.43,1.2,.77,1.95,1.01,.75,.24,1.56,.37,2.41,.37,.8,0,1.42-.14,1.87-.42,.45-.29,.67-.66,.67-1.12,0-.31-.13-.56-.39-.77-.26-.21-.72-.39-1.38-.55l-2.6-.6c-2.86-.65-4.29-2.15-4.27-4.52,0-1.3,.45-2.39,1.33-3.26s2.03-1.43,3.44-1.68l.02-2.65,3.2,.02Z"/>
</svg>
</template>

<script>
export default {
    name: "SalesTableIcon",
}
</script>

<style scoped>
    .cls-1 {
        fill: #fff;
    }
    
    .cls-2 {
        stroke-width: 2.5px;
    }
    
    .cls-2, .cls-3 {
        fill: none;
        stroke: #115c72;
        stroke-linecap: round;
        stroke-linejoin: round;
    }
    
    .cls-4 {
        fill: #59c5c7;
    }
    
    .cls-3 {
        stroke-width: 3.5px;
    }
</style>